import React, { useState } from 'react';

interface MobileIndicatorSelectProps {
  indicators: string[];
  displayNames: Record<string, string>;
  onIndicatorChange: (indicator: string) => void;
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  handleSwipeRight: () => void;
  handleSwipeLeft: () => void;
}

const MobileIndicatorSelect: React.FC<MobileIndicatorSelectProps> = ({
  indicators,
  displayNames,
  onIndicatorChange,
  currentIndex, 
  setCurrentIndex,
  handleSwipeRight,
  handleSwipeLeft,
}) => {
  

  const handlePrev = () => {
    handleSwipeRight();
  };

  const handleNext = () => {
    handleSwipeLeft();
  };

  const currentIndicator = indicators[currentIndex];
  const displayName = displayNames[currentIndicator] || currentIndicator;

  return (
    <div
      style={{
        width: 'calc(100% - 30px)',
        height: '47px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        padding: '8px',
        boxSizing: 'border-box',
        marginLeft: '15px',
        marginRight: '15px',
        marginTop: '10px',
      }}
    >
      {/* Left arrow */}
      <div
        onClick={handlePrev}
        style={{
          cursor: currentIndex > 0 ? 'pointer' : 'default',
          opacity: currentIndex > 0 ? 1 : 0.3,
          userSelect: 'none',
        }}
      >
        &#x25C0; {/* Unicode left triangle */}
      </div>

      {/* Current Indicator Display Name */}
      <div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '24px' }}>
        {displayName}
      </div>

      {/* Right arrow */}
      <div
        onClick={handleNext}
        style={{
          cursor: currentIndex < indicators.length - 1 ? 'pointer' : 'default',
          opacity: currentIndex < indicators.length - 1 ? 1 : 0.3,
          userSelect: 'none',
        }}
      >
        &#x25B6; {/* Unicode right triangle */}
      </div>
    </div>
  );
};

export default MobileIndicatorSelect;
